var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{attrs:{"id":"p"}},[_c('div',{staticStyle:{"flex":"1"}}),_vm._v(" "),_c('div',{attrs:{"id":"app"}},[_c('el-container',[_c('el-header',{attrs:{"height":"150px"}},[_c('HeaderContent')],1),_vm._v(" "),_c('el-main',[_c('TabContent')],1),_vm._v(" "),_c('el-footer',[_vm._v("\n        Sebastian's Lab\n      ")])],1)],1),_vm._v(" "),_c('div',{staticStyle:{"flex":"1"}})])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-69a41314","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/App.vue
// module id = XRSH
// module chunks = 1